import { actions } from "react-table";
import { createReducer } from "./../commons/js/utils/reducer";
const initialState = {
  currentPage: 1,
  pageCount: 1,
  isLoading: false,
  selectedPackageMaterial: null,
  selectedPoType: "active",
  newHeatNumber: "",
  isAllMtrEntered: false,
  noHeatNumbers: false,
  selectedImageType: { label: "BOL Image", value: "bol image" },
  packageMaterials: [],
  heatNumbers: [],
  attachmentTypes: [
    { label: "BOL Image", value: "bol image" },
    { label: "MTR Drag & Drop", value: "mtr drag & drop" },
  ],
  selectedHeatNumber: null,
  mtrFile: null,
  replaceMtrFlag: false,
  selectedFacility: {value: null, label: ''}
};

export const mtrManagmentReducer = createReducer(initialState, {
  SET_LOADING: (state, action) => {
    return {
      ...state,
      isLoading: action.payload.value,
    };
  },

  SET_SELECTED_PACKAGE_MATERIAL: (state, action) => {
    return {
      ...state,
      selectedPackageMaterial: action.payload.value,
    };
  },

  SET_SELECTED_IMAGE_TYPE: (state, action) => {
    return {
      ...state,
      selectedImageType: action.payload.value,
    };
  },

  SET_PO_TYPE: (state, action) => {
    return {
      ...state,
      selectedPoType: action.payload.value,
    };
  },

  SET_MTR_FILE: (state, action) => {
    return {
      ...state,
      mtrFile: action.payload.value,
    };
  },

  SET_PACKAGE_MATERIALS: (state, action) => {
    return {
      ...state,
      packageMaterials: action.payload.value,
    };
  },

  SET_HEAT_NUMBERS: (state, action) => {
    return {
      ...state,
      heatNumbers: action.payload.value,
    };
  },

  SET_NEW_HEATNUMBER: (state, action) => {
    return {
      ...state,
      newHeatNumber: action.payload.value,
    };
  },

  SET_IS_ALL_MTR_ENTERED: (state, action) => {
    return {
      ...state,
      isAllMtrEntered: action.payload.value,
    };
  },

  SET_NO_HEAT_NUMBERS: (state, action) => {
    return {
      ...state,
      noHeatNumbers: action.payload.value,
    };
  },

  SET_SELECTED_HEATNUMBER: (state, action) => {
    return {
      ...state,
      selectedHeatNumber: action.payload.value,
    };
  },

  SET_REPLACE_MTR: (state, action) => {
    return {
      ...state,
      replaceMtrFlag: action.payload.value,
    };
  },
  "SET_SELECTED_FACILITY_MTR": (state, action) => {
    return {
      ...state,
      selectedFacility: action.payload.facility
    }
  }
});

export default mtrManagmentReducer;
